import React, { useContext, useEffect } from "react";
import { getSortedArtists, initialArtistFilter } from "./FilterTypes/ArtistFilterType";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";
import MultiArtistList from "components/Picker/ArtistPicker/MultiArtistList";

interface Props {
  securityScope?: server.dto.ArtistSecurityScopes;
}

const ArtistFilter = (props: Props) => {
  const title = site.currentEnvironment.functionGroups.artist.singular;
  const applyRef = React.useRef<any>(null);

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("artist", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedArtists(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedArtists.length > 0,
    reset: () => initialArtistFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedArtists.map(a => a.artistId), b.selectedArtists.map(a => a.artistId))
  });
  useEffect(() => {
    setInitialValue("artist", initialArtistFilter);
  }, []);

  const [selectedArtists, setSelectedArtists] = React.useState<server.dto.ArtistSmall[]>(initialArtistFilter.selectedArtists);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedArtists(getValue("artist").selectedArtists);
    setPopupOpen(true);
  };

  const onArtistsSelected = (artists: server.dto.ArtistSmall[]) => {
    setSelectedArtists(artists);
    applyRef?.current?.focus();
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("artist", {
      selectedArtists
    });
    setPopupOpen(false);
  };

  if (!site.currentEnvironment.functionGroups.artist.enabled) {
    return <></>;
  }

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <MultiArtistList
        hideActiveFilter={false}
        securityScope={props.securityScope || "limitByUserAccess"}
        value={selectedArtists}
        onChange={artistForList => onArtistsSelected(artistForList)}
      />
    </MultiPickerFilterPopup>
  </div>
};


export default ArtistFilter;
